import type { FC, ReactNode } from 'react';
import { SpotIllustration } from '@george-labs.com/design-system';
import { SPOT_ILLUSTRATION } from '@george-labs.com/george-assets/illustrations';

import type { Severity } from '@api-client/temporary-messages';

const SEVERITY_ICON_CONFIG: Record<Severity, SPOT_ILLUSTRATION> = {
    INFO: SPOT_ILLUSTRATION.INFO_CIRCLE,
    WARNING: SPOT_ILLUSTRATION.WARNING,
    ERROR: SPOT_ILLUSTRATION.ERROR_CIRCLE,
};

interface Props {
    severity: Severity;
}

export const TeaserModalIllustration: FC<Props> = ({ severity }): ReactNode => (
    <SpotIllustration ornamental illustration={SEVERITY_ICON_CONFIG[severity]} />
);
